import { SearchType } from '@/types'

export interface BatchReserveCollectionListRequest {
  reserveNumFrom: number | null
  reserveNumTo: number | null
  holdingNumFrom: number | null
  holdingNumTo: number | null
  orderNumFrom: number | null
  orderNumTo: number | null
  searchType: SearchType[]
  outputOrder: string
  batchType: string
}

export function BatchReserveCollectionListRequestToJSON(
  value: BatchReserveCollectionListRequest
): any {
  return {
    reserve_num_from: value.reserveNumFrom,
    reserve_num_to: value.reserveNumTo,
    holding_num_from: value.holdingNumFrom,
    holding_num_to: value.holdingNumTo,
    order_num_from: value.orderNumFrom,
    order_num_to: value.orderNumTo,
    search_type: value.searchType,
    output_order: value.outputOrder,
    batch_type: value.batchType
  }
}
